import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Trophy } from "lucide-react";

const eur = (v) => `€${Number(v).toFixed(2).replace(".", ",")}`;

export const DiscountLeaderboard = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/discount-leaderboard").then((r) => setRows(r.data)).catch(() => {}); }, []);

  return (
    <Card className="rounded-2xl" data-testid="discount-leaderboard">
      <CardHeader><CardTitle className="font-heading text-lg flex items-center gap-2"><Trophy className="h-5 w-5 text-accent" /> Classifica codici sconto</CardTitle></CardHeader>
      <CardContent className="overflow-x-auto">
        {rows.length === 0 ? <p className="text-sm text-muted-foreground py-4 text-center">Nessun codice ancora.</p> : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>#</TableHead><TableHead>Codice</TableHead>
                <TableHead className="text-right">Mensili</TableHead><TableHead className="text-right">Annuali</TableHead>
                <TableHead className="text-right">Totale</TableHead><TableHead className="text-right">Incasso 1° pagamento</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((r, i) => (
                <TableRow key={r.code} data-testid={`leaderboard-row-${r.personal ? "personal" : r.code}`}>
                  <TableCell className="font-mono-data text-muted-foreground">{i + 1}</TableCell>
                  <TableCell>
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="font-mono-data font-semibold">{r.code}</span>
                      {i === 0 && r.total > 0 && <Badge variant="outline" className="bg-accent/15 text-accent border-accent/30">Top</Badge>}
                    </div>
                    {r.label && <div className="text-xs text-muted-foreground">{r.label}</div>}
                  </TableCell>
                  <TableCell className="text-right font-mono-data">{r.monthly}</TableCell>
                  <TableCell className="text-right font-mono-data">{r.yearly}</TableCell>
                  <TableCell className="text-right font-mono-data font-semibold" data-testid={`leaderboard-total-${r.personal ? "personal" : r.code}`}>{r.total}</TableCell>
                  <TableCell className="text-right font-mono-data" data-testid={`leaderboard-revenue-${r.personal ? "personal" : r.code}`}>{eur(r.revenue)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
        <p className="text-xs text-muted-foreground mt-3">Conteggio dei pagamenti completati con codice. L'incasso è stimato sul primo pagamento scontato.</p>
      </CardContent>
    </Card>
  );
};
